import { useRef, useEffect } from "react";

const VideoSection = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          video.pause();
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="video-section">
      <video
        ref={videoRef}
        className="video-player"
        src="https://videos.storyworks42.com/vectr42_video.mp4"
        playsInline
        controls
      />
    </section>
  );
};

export default VideoSection;
